module.exports = __webpack_public_path__ + "static/media/pic01.f5ed6a58.png";